// removed by extract-text-webpack-plugin
module.exports = {"osInputContainer":"_1vlaH4qvvzyOY1TOg85wm2","osInputText":"_1LlAkytoiq62l47XIad9Jb","osInputTextW":"_1yoXhyM6RF9YonGTWoBrdL"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/Email/styles.css
// module id = 2946
// module chunks = 0